import React from 'react'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import { useIntl } from 'react-intl'
import messages from './messages'
import NewOrderModal from 'components/NewOrderModal'
import NiceModal  from '@ebay/nice-modal-react'
import { useHistory } from 'react-router-dom'

const DuplicateOrder = ({ order, readOnly = false }) => {
  const history = useHistory()
  const { formatMessage } = useIntl()

  return (
    <Menu.Item key='duplicate' disabled={readOnly}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={() => NiceModal.show(NewOrderModal, { history, duplicate: true, orderId: order.uid })}>
          { formatMessage(messages.title) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default DuplicateOrder
